module.exports = __webpack_public_path__ + "static/ey-8-sq-5fb8f5338b9f40f4b39b338f5a3b256b.png";